/*
 * Posterly location search override
 *
 * This script patches Posterly's built‑in search_location method to use
 * the open Nominatim geocoding service instead of Posterly's own service,
 * which currently returns empty results. It waits for the global
 * `window.appx` Vue instance to be available and then overrides the
 * `search_location` method. Each call to the patched method will query
 * Nominatim for matching places and update the `cf.search_results`
 * property with an array of suggestion objects. These suggestion objects
 * match the shape expected by Posterly's built‑in `change_location`
 * method, so choosing a suggestion will update the map and star map
 * correctly.
 */

(function() {
  function overridePosterlySearch() {
    if (typeof window === 'undefined' || !window.appx || typeof window.appx.search_location !== 'function') {
      setTimeout(overridePosterlySearch, 250);
      return;
    }
    var appx = window.appx;
    var originalSearch = appx.search_location;
    if (appx._search_location_patched) {
      return;
    }
    appx.search_location = async function(cf) {
      var query = cf && cf.search_location ? String(cf.search_location).trim() : '';
      if (!query) {
        cf.search_results = [];
        if (typeof this.$forceUpdate === 'function') {
          this.$forceUpdate();
        }
        return;
      }
      if (query.length < 2) {
        return;
      }
      try {
        var endpoint = 'https://nominatim.openstreetmap.org/search';
        var params = new URLSearchParams({
          q: query,
          format: 'json',
          addressdetails: '1',
          limit: '5'
        });
        var requestUrl = endpoint + '?' + params.toString();
        var response = await fetch(requestUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error('Geocoding request failed with status ' + response.status);
        }
        var data = await response.json();
        cf.search_results = Array.isArray(data) ? data.map(function(item) {
          var addr = item.address || {};
          return {
            place_name: item.display_name || query,
            city: addr.city || addr.town || addr.village || addr.county || '',
            region: addr.state || addr.region || addr.province || '',
            country: addr.country || '',
            center: {
              lat: parseFloat(item.lat),
              lon: parseFloat(item.lon)
            },
            zoom: 12
          };
        }) : [];
        if (typeof this.$forceUpdate === 'function') {
          this.$forceUpdate();
        }
      } catch (err) {
        console.error('Posterly location fix: fallback to original search due to error', err);
        if (typeof originalSearch === 'function') {
          try {
            originalSearch.call(this, cf);
          } catch (fallbackErr) {
            console.error('Posterly location fix: fallback search also failed', fallbackErr);
          }
        }
      }
    };
    appx._search_location_patched = true;
    console.log('Posterly location search override initialised');
  }
  overridePosterlySearch();
})();